import { Component, Injector, OnInit } from '@angular/core';

@Component({
  selector: 'app-barra-simple',
  standalone: false,
  template: `
    <div class="header-mainInfo">
      <div *ngFor="let titulo of titulos; let i = index">
        <h1>
          <a *ngIf="titulo.link.length > 0; else sinRoute" class="control-item" [routerLink]="titulo.link">
            {{ titulo.texto }}
          </a>
          <ng-template #sinRoute>
            {{ titulo.texto }}
          </ng-template>
          <span *ngIf="i < titulos.length - 1">/&nbsp;</span>
        </h1>
      </div>
      <span class="spacer"></span>
    </div>
  `
})
export class BarraSimpleComponent implements OnInit {

  titulos: Array<{ texto: string, link: Array<string> }>;

  constructor(private injector: Injector) { }

  ngOnInit(): void {
    this.titulos = this.injector.get('titulos');
  }

}
